import { pagesExtraData } from "@/data/pagesData";

export default class Purl {
  constructor(purl, cms) {
    if (!purl) return null;
    const cmsData = cms.reduce(
      (accumulator, target) => ({ ...accumulator, [target.id]: target }),
      {}
    );

    const keyMap = {
      CLIENT_NAME: "client",
      REP_NAME: "first",
      REP_EMAIL: "email",
      REP_PHONE: "phone",
      PAGE_ID: "id",
      PAGE_TITLE: "title",
      PAGE_ROUTE_NAME: "routeName",
      PAGE_PARENT_ID: "parentId",
      PAGE_COPY: "copy",
      PAGE_IMAGE: "image",
      PAGE_ATTACHMENT_TITLE: "attachmentTitle",
    };

    const SUMMARY_PAGE_ID = "10";

    this.client = mapClientInfo();
    this.rep = mapRepInfo();
    this.pages = mapPages();

    //* Map client info
    function mapClientInfo() {
      return {
        name: purl[keyMap.CLIENT_NAME],
      };
    }

    //* Map rep info
    function mapRepInfo() {
      return {
        name: purl.rep[keyMap.REP_NAME],
        email: purl.rep[keyMap.REP_EMAIL],
        phone: purl.rep[keyMap.REP_PHONE],
      };
    }

    //* Map pages data
    function mapPages() {
      return purl?.pages?.map((page) => {
        const extraData = cmsData[page[keyMap.PAGE_ID]];
        return {
          id:
            typeof page[keyMap.PAGE_ID] === "string"
              ? Number.parseInt(page[keyMap.PAGE_ID])
              : page[keyMap.PAGE_ID],
          title: page[keyMap.PAGE_TITLE],
          routeName: page[keyMap.PAGE_ROUTE_NAME],
          parentId: page[keyMap.PAGE_PARENT_ID],
          //* Add extra data to page
          ...(extraData && {
            extraData,
          }),
          //* Add summary data
          ...(page.id === SUMMARY_PAGE_ID && {
            Summary: {
              copy: page[keyMap.PAGE_COPY],
              image: page[keyMap.PAGE_IMAGE],
              attachmentTitle: page[keyMap.PAGE_ATTACHMENT_TITLE],
            },
          }),
        };
      });
    }
  }
}
